import React from "react";
import BannerBackground from "../Assets/Back1.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";

const Home = () => {
  return (
    <div className="home-container" id="home">
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Kanha Enterprises
          </h1>
          <p className="primary-text">
            Your One Stop Solution For Housekeeping, Deepcleaning , Security & Manpower Outsourcing Services
          </p>
          <a className="secondary-button" href="#Footer">
            Contact Now <FiArrowRight />{" "}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
